import { ProductReferencesEffects } from './product-references.effect';
import { ProductReviewsEffects } from './product-reviews.effect';
import { ProductEffects } from './product.effect';

export const effects: any[] = [ProductEffects, ProductReviewsEffects, ProductReferencesEffects];

export * from './product-references.effect';
export * from './product-reviews.effect';
export * from './product.effect';
